import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_StatusColorIndicatorOption.scss';
import StatusColorIndicator from './StatusColorIndicator';

import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';

/**
 * Renders a dropdown option with a status color indicator and a label
 */
const StatusColorIndicatorOption = props => {
  const classes = classNames('StatusColorIndicatorOption', props.classNames, {
    'StatusColorIndicatorOption--disabled': props.disabled
  });

  return (
    <div className={classes} style={props.style}>
      <div className="StatusColorIndicatorOption__text-container">
        <div className="StatusColorIndicatorOption__top-text-container">
          <StatusColorIndicator statusColor={props.statusColor} />
          <span className="StatusColorIndicatorOption__label">{props.label}</span>
        </div>
        {props.subText && (
          <span className="StatusColorIndicatorOption__subtext">{props.subText}</span>
        )}
      </div>
    </div>
  );
};

StatusColorIndicatorOption.propTypes = {
  /**
   * The color of the status.
   */
  statusColor: PropTypes.oneOf(objectValues(StatusColorIndicator.Colors)).isRequired,
  /**
   * The option label.
   */
  label: PropTypes.string.isRequired,
  /**
   * Sub text for the option.
   */
  subText: PropTypes.string,
  /**
   * Additional className.
   */
  classNames: PropTypes.string,
  /**
   * A custom style for the container element of the component.
   */
  style: PropTypes.object,
  /**
   * Whether the component should render in a disabled state.
   */
  disabled: PropTypes.bool
};

export default StatusColorIndicatorOption;
